import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'have_wrkrs_been_denied_access_to_any_of_their_original_personal'

export const dataPointDefinition = {
  retracedId: 'have_wrkrs_been_denied_access_to_any_of_their_original_personal',
  name: 'Have workers been denied access to any of their original personal documents (such as birth certificates, passports, work permits and ID cards) when they need them?',
  description:
    "Ordinarily, workers should keep their original personal documents themselves. In some cases, employers may be allowed to hold on to workers' documents, for example, if necessary to ensure that the documents are secure. However, workers should freely and knowingly consent to this, and they should be allowed to access their original personal documents. Examples of personal documents are: passports, government issued ID, birth certificates, land deeds, diplomas, certificates, ATM/cash cards. \r\r\n\r\r\nWhile written consent is ideal, it is not sufficient to show that the consent was freely and knowingly provided. Workers must be interviewed to confirm this. \r\r\n\r\r\nAnswer No if workers have freely and knowingly consented to have their documents held, and the employer provides workers with access to the documents (ideally, access should be provided 24 hours per day, 7 days per week, but a lesser level of access is acceptable if workers state that they have adequate access).\r\r\n\r\r\nAnswer Yes if workers cannot adequately access their documents, if workers did not freely consent to have them held, or if workers' written consent was not freely and knowingly provided. \r\r\n\r\r\nAnswer No if access is not possible while the worker's official documents are being renewed, unless it can be shown that the employer is colluding with the authorities in an effort to force workers to remain on the job.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-14--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10040,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
